import React, { useEffect, useState } from 'react';
import { RouterProvider } from 'react-router-dom';

// project imports
import router from 'routes';
import ThemeCustomization from 'themes';
import ScrollTop from 'components/ScrollTop';

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

export default function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // 1. Obtenemos los datos del almacenamiento
    const lastLoginDate = localStorage.getItem('lastLoginDate');
    const user = localStorage.getItem('user');
    const today = new Date().toDateString(); 

    // 2. Si es un nuevo día, borramos la sesión
    if (lastLoginDate !== today) {
      localStorage.removeItem('user'); 
      localStorage.removeItem('lastLoginDate');
    }
    
    // 3. VERIFICACIÓN ESTRICTA: Volvemos a leer el usuario por si se acaba de borrar
    const activeUser = localStorage.getItem('user');

    // Si NO hay usuario y NO estamos en la pantalla de login, lo expulsamos
    if (!activeUser && window.location.pathname !== '/login') {
      window.location.href = '/login';
    } else {
      // Si hay usuario o ya está en el login, permitimos que la app cargue
      setLoading(false); 
    }
  }, []);

  // Mantiene la pantalla en blanco una fracción de segundo para que no se vea el dashboard por error
  if (loading) {
    return null; 
  }

  return (
    <ThemeCustomization>
      <ScrollTop>
        <RouterProvider router={router} />
      </ScrollTop>
    </ThemeCustomization>
  );
}